import Button from "../../../independent/Button";
import AddHistory from "../organisms/AddHistory";


const AddHistoryButton = ({componentMount, subModalMount, closeModal, closeSubModal}) => {

  return (
    <button className={"add-history-button"}
            type={"button"}
            onClick={() => componentMount(
              <AddHistory subModalMount={subModalMount} closeModal={closeModal} closeSubModal={closeSubModal}/>)}
    >
      Add New Design
    </button>
  )
}

export default AddHistoryButton;
